import { Component, ElementRef, Inject } from '@angular/core';
import { ConfirmComponent, ConfirmData } from './confirm.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoggingService } from '../../services/logging/logging.service';
import { ResponseStatus } from '../../../common/Interfaces';

@Component({
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: false
})
export class UnsavedChangesComponent extends ConfirmComponent {
    constructor (
        public dialogRef: MatDialogRef<ConfirmComponent>,
        protected log: LoggingService,
        elementRef: ElementRef<HTMLElement>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmData
    ) {
        super(dialogRef, log, elementRef, data);
        this.log.verbose({ type: 'UnsavedChangesComponent', data });
        const options = data || {};
        this.data = {
            ...{
                showOk: true,
                showCancel: true,
                okText: 'OK',
                cancelText: 'Cancel',
                dialogText:
                    'You have unsaved changes on this page.<br/>Navigate away and lose changes?',
                headerText: 'Confirmation',
                okClass: 'p-button-warning p-button-text',
                cancelClass: 'p-button-primary p-button-text',
                baseZIndex: 99999999,
                maxStatus: ResponseStatus.None
            },
            ...options
        };
        this.log.verbose({ type: 'UnsavedChangesComponent', data });
    }
}
